import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from '@order/services/order.service';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-additional-instructions-modal',
  templateUrl: './additional-instructions-modal.component.html',
  styleUrls: ['./additional-instructions-modal.component.scss'],
})
export class AdditionalInstructionsModalComponent {
  internalInstructions: string;
  isEditing: boolean;
  addedDeliveryInstructions = false;
  @Output() instructionsAdded = new EventEmitter<boolean>();

  @Input() set instructions(val: string) {
    this.internalInstructions = val?.trim();
    this.isEditing = !!this.internalInstructions;
  }

  constructor(
    readonly platformService: PlatformService,
    private translateService: TranslateService,
    private modalController: ModalController,
  ) {}

  handleInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!this.addedDeliveryInstructions && input.value?.trim()) {
      this.addedDeliveryInstructions = true;
      this.instructionsAdded.emit(this.addedDeliveryInstructions);
    }
  }

  async closeModal() {
    await this.modalController.dismiss({ save: false });
  }

  async saveModal() {
    await this.modalController.dismiss({
      save: true,
      instructions: this.internalInstructions?.trim(),
    });
  }
}
